<div class="modal-body submit-proof">
  <span class="dialog-close" (click)="onClose()">X</span>
  <form [formGroup]="submitProofForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12 px-0 ps-lg-3">
        <div class="activity-content mb-4" [innerHTML]="activity.content! | safeHtml"></div>
        <div class="d-flex justify-content-between align-items-center mb-4">
          <span class="evidence-text">Upload evidence:</span>
          <span class="mandatory-text">* Mandatory fields</span>
        </div>
        <div class="form-group mb-4" *ngIf="showAllFields || dateRequired || !submitProofForm.value?.sprintActivityId">
          <label>{{ 'Date of activity' | translate }}*</label>
          <input type="date" class="form-control" formControlName="activityDate" [min]="minDate" [max]="maxDate" />
          <span class="error" *ngIf="submitted && submitProofForm.controls['activityDate'].invalid"
            >Date is required.</span
          >
        </div>
        <div
          class="form-group mb-4"
          *ngIf="showAllFields || BDFNumberRequired || !submitProofForm.value?.sprintActivityId"
        >
          <label>{{ 'BDF Number' | translate }}</label>
          <input type="text" class="form-control" formControlName="BDFNumber" />
          <span class="error" *ngIf="submitted && submitProofForm.controls['BDFNumber'].invalid"
            >BDF number is required.</span
          >
        </div>
        <div
          class="form-group mb-4"
          *ngIf="showAllFields || resellerNameRequired || !submitProofForm.value?.sprintActivityId"
        >
          <label>Name of broad channel partner(s)</label>
          <div class="d-flex flex-column flex-sm-row gap-2 justify-content-between mb-4">
            <input type="text flex-grow-1" class="form-control" #resellerInput />
            <button
              type="button"
              class="btn btn-outline-primary add-reseller-button"
              (click)="addResellerName(resellerInput.value); resellerInput.value = ''"
            >
              Add
            </button>
          </div>
          <div class="reseller-section d-flex flex-column p-2">
            <div class="d-flex flex-column flex-grow-1 gap-3">
              <div *ngFor="let reseller of this.submitProofForm.get('resellerNames')?.value; let i = index">
                <span>{{ reseller }}</span>
                <fa-icon [icon]="['far', 'trash']" class="ms-3" (click)="removeResellerName(i)"></fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <label>Activity</label>
          <input type="text" class="form-control" formControlName="activityTitle" />
        </div>
        <div class="form-group mb-4">
          <label>{{ 'Upload supporting proof' | translate }}*</label>
          <div class="files-section d-flex flex-column p-2">
            <div class="d-flex flex-column flex-grow-1 gap-3">
              <div *ngFor="let file of files.controls; let i = index">
                <img [src]="getIconName(file.value.file)" class="file-icon" />
                <span>{{ file.value.file.name }}</span>
                <fa-icon [icon]="['far', 'trash']" class="ms-3" (click)="removeFile(i)"></fa-icon>
              </div>
            </div>
          </div>
          <span class="filename mt-2">{{ currentFile?.name }}</span>
          <span class="error" *ngIf="submitted && files.invalid && files.value.length < 1">
            Supporting proof is required.</span
          >
          <span class="error" *ngIf="submitted && files.invalid && files.value.length > 0">
            {{ 'Upload_proof_validation_message' | translate }}</span
          >
          <div class="d-flex flex-column mt-5">
            <div class="custom-file-upload">
              <input type="file" (change)="handleFileUpload($event)" multiple #inputFile />
              <span class="btn-file" (click)="inputFile.click()">Browse Files</span>
            </div>
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-submit px-3 px-sm-5 mt-3"
          [ngClass]="{ disabled: disableSubmitButton }"
        >
          Submit {{ activity.title }} proof documents
        </button>
      </div>
      <div class="col-12 mt-3 mb-3 ps-0 ps-sm-3">
        <p class="d-flex gap-1 flex-wrap">
          <b>Need help?</b> Contact us:
          <b><span [innerHTML]="'contact_us_link' | translate | safeHtml"></span></b>
        </p>
      </div>
    </div>
  </form>
</div>
